import { useMutation } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export interface RecordCalendarExportParams {
  matterId: string;
  eventId: string;
  recipientCount: number;
}

export const useRecordProceduralCalendarExport = () => {
  const { getFetchConfig } = useGetFetchConfig();

  return useMutation<void, Error, RecordCalendarExportParams>(async ({ matterId, eventId, recipientCount }) => {
    const res = await fetch(
      `${APIBaseChronos}/api/matter/${matterId}/procedural-timeline/events/${eventId}/calendar-export`,
      getFetchConfig({ method: FetchMethod.POST, data: { recipientCount } }),
    );
    if (!res.ok) {
      throw new Error('Failed to record calendar export');
    }
  });
};
